export const isMoreThanDaysOld = (dateString, day = 7) => {
  if (dateString) {
    const givenDate = new Date(dateString);
    const currentDate = new Date();
    const sevenDaysInMilliseconds = day * 24 * 60 * 60 * 1000; // 7 days

    // Subtract the given date from the current date
    const difference = currentDate - givenDate;

    // Check if the difference is greater than seven days
    return difference > sevenDaysInMilliseconds;
  } else {
    return false;
  }
};

export const isValidHost = (url, hosts) => {
  try {
    // Create a new URL object from the input string.
    const parsedUrl = new URL(url);
    // Extract the hostname from the URL object.
    const hostname = parsedUrl.hostname;

    // Check if the extracted hostname is in the list of invalid hosts.
    // Returns false if the hostname is found in the hosts array, true otherwise.
    return !hosts.includes(hostname);
  } catch (error) {
    // If there's an error parsing the URL, return false or handle accordingly.
    console.error("Invalid URL:", error.message);
    return false; // or throw new Error('Invalid URL') depending on your needs.
  }
};

export const shortenEmail = (email, maxLength = 28) => {
  if (!email || email.length <= maxLength) {
    return email;
  }

  const [username, domain] = email.split("@");
  const [domainName, tld] = domain.split(".");

  // Start with full username and domain
  let shortenedUsername = username;
  let shortenedDomain = domain;

  // First, try to shorten the username
  if ((shortenedUsername + "@" + shortenedDomain).length > maxLength) {
    const availableSpace = maxLength - shortenedDomain.length - 3; // 3 accounts for '@' and '..'
    shortenedUsername = username.slice(0, Math.max(1, availableSpace)) + "..";
  }

  // If still too long, then truncate the domain (before the dot)
  if ((shortenedUsername + "@" + shortenedDomain).length > maxLength) {
    const availableSpace = maxLength - shortenedUsername.length - 5; // 5 accounts for '@', '..', and '.'
    shortenedDomain = domainName.slice(0, Math.max(1, availableSpace - tld.length)) + ".." + "." + tld;
  }

  return `${shortenedUsername}@${shortenedDomain}`;
};

export const secondaryPayload = (source) => {
  // Initialize the new object with specific keys from the source
  const transformed = {
    linkedin_profile_id: source.linkedin_profile_id || "",
    job_title: source.job_title || "",
    location: source.location || "",
    skills: Array.isArray(source.skills) ? source.skills : [],
    languages: Array.isArray(source.languages) ? source.languages : [],
    licenses_certifications: Array.isArray(source.licenses_certifications)
      ? source.licenses_certifications
      : [],
    educations: Array.isArray(source.educations)
      ? source.educations.map((education) => ({
          institute_linkedin_url: education.institute_linkedin_url || "",
          institute: education.institute || "",
          program: education.program || "",
          start_year: education.start_year || "",
          end_year: education.end_year || "",
        }))
      : [],
    work_experience: Array.isArray(source.work_experience)
      ? source.work_experience.map((exp) => ({
          company_name: exp.company || "",
          job_title: exp.designation || "",
          description: exp.description || "",
          location: exp.location || "",
          start_date: exp.start_date || "",
          end_date: exp.end_date || "",
          is_current: typeof exp.is_current === "boolean" ? exp.is_current : false,
          company_linkedin_url: exp.companyURL || "",
        }))
      : [],
  };

  return transformed;
};

export const crmRecordKeyValue = (type, apiName, crmObjectsConfig = []) => {
  try {
    const obj = crmObjectsConfig.find((obj) => obj.type === type && obj.crm_object_api_name === apiName);
    const personFields = [
      { key: "job_title", label: "Job Title", crm_field_api_name: "" },
      {
        key: "company",
        label: "Company name",
        crm_field_api_name: "",
      },
      { key: "city", label: "City", crm_field_api_name: "" },
      { key: "state", label: "State", crm_field_api_name: "" },
      { key: "country", label: "Country", crm_field_api_name: "" },
      // {
      //   key: "record_owner",
      //   label: "Record Owner",
      //   crm_field_api_name: "",
      // },
      {
        key: "crm_owner_name",
        label: "Record Owner",
        crm_field_api_name: "crm_owner_name",
      },
    ];
    const companyFields = [
      { key: "domain", label: "Domain", crm_field_api_name: "" },
      {
        key: "headquarters_city",
        label: "City",
        crm_field_api_name: "",
      },
      {
        key: "headquarters_state",
        label: "State",
        crm_field_api_name: "",
      },
      {
        key: "headquarters_country",
        label: "Country",
        crm_field_api_name: "",
      },
      {
        key: "employee_count",
        label: "Employee count",
        crm_field_api_name: "",
      },
      // {
      //   key: "record_owner",
      //   label: "Record Owner",
      //   crm_field_api_name: "",
      // },
      {
        key: "crm_owner_name",
        label: "Record Owner",
        crm_field_api_name: "crm_owner_name",
      },
    ];
    let staticFields = [];
    const mapFields = [];
    if (type === "person") {
      staticFields = personFields;
    } else {
      staticFields = companyFields;
    }
    staticFields.map((el) => {
      if (obj && obj.mappings && obj.mappings.length > 0) {
        let mapobj = {};
        mapobj = obj.mappings.find((map) => map.system_field_name === el?.key);
        mapFields.push({
          system_field_name: el?.key,
          label: mapobj?.crm_field_label ? mapobj?.crm_field_label : el?.label,
          crm_field_api_name: mapobj?.crm_field_api_name
            ? mapobj?.crm_field_api_name
            : el?.crm_field_api_name,
        });
      }
    });

    const transformedArray = mapFields.reduce(
      (acc, item) => {
        // Check for location fields
        const locationKeys =
          type === "person"
            ? ["city", "state", "country"]
            : ["headquarters_city", "headquarters_state", "headquarters_country"];

        if (locationKeys.includes(item.system_field_name)) {
          acc.location = acc.location || {
            system_field_name: "location",
            label: "Location",
            location: {},
          };

          const uniformKey =
            item.system_field_name === "headquarters_city"
              ? "city"
              : item.system_field_name === "headquarters_state"
                ? "state"
                : item.system_field_name === "headquarters_country"
                  ? "country"
                  : item.system_field_name;

          acc.location.location[uniformKey] = item;
        } else {
          acc.fields.push(item);
        }
        return acc;
      },
      { fields: [], location: null }
    );

    const returnArr = [...transformedArray.fields];
    if (transformedArray.location) {
      if (type === "person") {
        returnArr.splice(2, 0, transformedArray.location);
      } else {
        returnArr.splice(1, 0, transformedArray.location);
      }
    }

    // console.log("returnArr", returnArr);
    return returnArr;
  } catch (error) {
    console.error("Error:", error);
    return [];
  }
};

export const truncateValue = (value, maxLength = 60) => {
  if (!value) return "";
  if (value.length > maxLength) {
    return value.slice(0, maxLength) + "...";
  }
  return value;
};
